import { type Branding, TranslationLanguage } from "@hopper-b2b/types";
import { ROOT_LANGUAGE_REGEX } from "./getRootLang";

export const getFallbackLanguages = (branding: Branding) => {
  // Default source language is English if not otherwise specified
  const sourceLanguage = branding.sourceLanguage ?? TranslationLanguage.en;
  const fallbackLanguages: string[] =
    sourceLanguage !== TranslationLanguage.en ? [] : [TranslationLanguage.en];
  if (branding.default != null && branding.default !== TranslationLanguage.en) {
    const brandDefaultLanguage = branding.default;
    const primaryLanguage =
      brandDefaultLanguage.match(ROOT_LANGUAGE_REGEX)?.[1];
    if (
      brandDefaultLanguage === primaryLanguage ||
      primaryLanguage === TranslationLanguage.en
    ) {
      fallbackLanguages.unshift(brandDefaultLanguage);
    } else {
      if (primaryLanguage != null) {
        fallbackLanguages.unshift(primaryLanguage);
      }
      fallbackLanguages.unshift(brandDefaultLanguage);
    }
  }
  return fallbackLanguages;
};
